"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AmazonDisclaimer = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var AmazonDisclaimer =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(AmazonDisclaimer, _Component);

  function AmazonDisclaimer(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = AmazonDisclaimer.prototype;

  _proto.render = function render() {
    return _react.default.createElement("p", null, "We are a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for us to earn fees by linking to Amazon.com and affiliated sites.");
  };

  return AmazonDisclaimer;
}(_react.Component);

exports.AmazonDisclaimer = AmazonDisclaimer;